export const sprs = [
    {
        index: 1,
        slug: 'unauthorized-admin-page-login',
        title: 'Unauthorized Admin Page Login',
        description:
            'The admin page is accessible by the public! This needs to be addressed immediately as it is a high risk.',
        reportedBy: 'Samer',
        priority: 'High',
        status: 'New',
        type: 'Issue',
        resolution: ''
    },
    {
        index: 2,
        slug: 'missign-cjm-process',
        title: 'Missing Customer Journey Map Task',
        description:
            'The system is missing the capability to add Customer Journey Maps to the services.',
        reportedBy: 'Joni Mitchel',
        priority: 'Medium',
        status: 'New',
        type: 'New Feature',
        resolution: ''
    },
    {
        index: 3,
        slug: 'include-service-id-in-export',
        title: 'Include Service ID in Export',
        description:
            'When exporting the services in the system, the service ID should also be exported so that we can always reference to the crrect servcie.',
        reportedBy: 'Cat Stevens',
        priority: 'Low',
        status: 'Resolved',
        type: 'Enhancement',
        resolution: 'Added the Service ID column to the export file.'
    },
    {
        index: 4,
        slug: 'profile-picture-not-updating',
        title: 'Profile picture not updating',
        description:
            'Users reported that when they try to update their profile picture, the system tells them picture saved, but it is not really saved.  The old picture is retained.',
        reportedBy: 'Jimi Hendrix',
        priority: 'Low',
        status: 'New',
        type: 'Issue',
        resolution: ''
    },
    {
        index: 5,
        slug: 'cjm-download-is-not-working',
        title: 'CJM download is not working',
        description:
            'When users click on the download icon for CJMs, nothing happens.',
        reportedBy: 'Jack Black',
        priority: 'Medium',
        status: 'Verified',
        type: 'Issue',
        resolution: ''
    },
    {
        index: 6,
        slug: 'logo-update',
        title: 'Logo needs to be updated to the new one.',
        description:
            'Some pages still have the old logo. The new one needs to be used in all pages.',
        reportedBy: 'Eric Clapton',
        priority: 'High',
        status: 'New',
        type: 'New Feature',
        resolution: ''
    }
]